import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-upload-req-update-location-modal',
  templateUrl: './upload-req-update-location-modal.component.html'
})
export class UploadReqUpdateLocationModalComponent {

  modalData: any = {};

  constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  saveCallback(locationObject) {
    this.closeModal();
    if (this.modalData.saveCallback) {
      this.modalData.saveCallback(locationObject);
    }
  }

  clearLocation() {
    this.closeModal();
    if (this.modalData.clearCallback) {
      this.modalData.clearCallback();
    }
  }
}
